// OBS: this file is written by the buildscript!
const FrontendBuildCommit = "fa7c2ef";
export default FrontendBuildCommit;